<template>
  <transition name="fade">
    <div class="page" v-if="isShow" @click="handleClose">
      <img class="share" :src="shareArrow" />
    </div>
  </transition>
</template>
<script>
import store from '@/store'
export default {
  name: 'shareBox',
  data() {
    return {
      isShow: false,
      shareArrow: store.state.imgHeadUrl + 'share_arrow.png'
    }
  },
  methods: {
    handleClose() {
      this.isShow = false
    }
  }
}
</script>
<style lang="less" scoped>
.page {
  width: 100%;
  height: 100%;
  position: fixed;
  background: rgba(0, 0, 0, 0.7);
  z-index: 9999;
  top: 0;
}

.share {
  width: 176px;
  // height: 95px;
  position: absolute;
  right: 28px;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
